import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
import React, { useCallback, useState } from "react";

import ManagePropertiesView from "./ManagePropertiesView";

const emptyProperty = {};

const ManagePropertiesContainer = () => {
  const permission = useCurrentPermission();

  const [openedCollapses, setOpenedCollapses] = useState(["displayCard"]);
  const [openUpdateCard, setOpenUpdateCard] = useState(false);
  const [openLabel, setOpenLabel] = useState(false);
  const [openOrder, setOpenOrder] = useState(false);
  const [elemToUpdate, setElemToUpdate] = useState(emptyProperty);

  const collapsesToggle = useCallback(
    (collapse) => {
      if (collapse === "displayCard") {
        setOpenUpdateCard(false);
        setOpenLabel(false);
        setOpenOrder(false);
      }
      if (!openedCollapses.includes(collapse)) {
        setOpenedCollapses([collapse]);
      }
    },
    [openedCollapses]
  );

  const handleUpdate = useCallback(
    (elem) => {
      collapsesToggle("editCard");
      setOpenUpdateCard(true);
      setOpenLabel(false);
      setOpenOrder(false);
      setElemToUpdate(elem);
    },
    [collapsesToggle]
  );

  const handleLabel = useCallback(
    (elem) => {
      collapsesToggle("editCard");
      setOpenUpdateCard(false);
      setOpenLabel(true);
      setOpenOrder(false);
      setElemToUpdate(elem);
    },
    [collapsesToggle]
  );

  const handleOrder = useCallback(
    (elem) => {
      collapsesToggle("editCard");
      setOpenUpdateCard(false);
      setOpenLabel(false);
      setOpenOrder(true);
      setElemToUpdate(elem);
    },
    [collapsesToggle]
  );

  return (
    <ManagePropertiesView
      permission={permission}
      openedCollapses={openedCollapses}
      openUpdateCard={openUpdateCard}
      openLabel={openLabel}
      openOrder={openOrder}
      elemToUpdate={elemToUpdate}
      collapsesToggle={collapsesToggle}
      handleUpdate={handleUpdate}
      handleLabel={handleLabel}
      handleOrder={handleOrder}
    />
  );
};

export default ManagePropertiesContainer;
